import { defineStore } from 'pinia'
import api from '@/api/index.js'

export const useAppStore = defineStore('app', {
  state: () => ({
    csrfToken: '',
    isLoading: false,
  }),
  actions: {
    setCsrfToken(token) {
      this.csrfToken = token
    },

    async fetchToken() {
      let token = await api.fetchCsrfToken(this.refreshToken)
      this.setCsrfToken(token)
    },

    showLoading(value) {
      this.isLoading = value
    },
  },
  persist: false,
})
